import React from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";
import { makeStyles } from "@material-ui/core/styles";
import { AddNewButton } from "./AddNewButton";
import { Progress } from "./Progress";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Grid from "@material-ui/core/Grid";
import SearchInput from "./SearchInput";
import { PaginationActions } from "./PaginationActions";

const MainTable = ({
  title,
  subtitle,
  headers,
  rows,
  onRowClick,
  addNewTitle,
  onAddNewClick,
  loading
}) => {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("");
  const [query, setQuery] = React.useState("");

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleRequestSort = (event, property) => {
    const isDesc = orderBy === property && order === "desc";
    setOrder(isDesc ? "asc" : "desc");
    setOrderBy(property);
  };

  let genericKey = 0;

  const classes = useTableStyles();

  return (
    <div>
      {loading && <Progress />}
      <Grid container justify="space-between">
        <Grid item xs={8}>
          <Typography variant="h5" className={classes.pageTitle}>
            {title}
            {addNewTitle && (
              <AddNewButton onClick={onAddNewClick} title={addNewTitle} />
            )}
          </Typography>
          <Typography variant="subtitle2" className={classes.pageSubTitle}>
            {subtitle}
          </Typography>
        </Grid>
        <Grid item xs={4} className={classes.searchContainer}>
          <SearchInput value={query} onChange={setQuery} />
        </Grid>
      </Grid>

      <Paper>
        <div className={classes.tableWrapper}>
          <Table>
            <TableHead>
              <TableRow>
                {headers.map(header => (
                  <TableCell
                    key={genericKey++}
                    className={classes.header}
                    sortDirection={orderBy === header.id ? order : false}
                  >
                    {header.sortable ? (
                      <TableSortLabel
                        active={orderBy === header.id}
                        direction={order}
                        onClick={event => handleRequestSort(event, header.id)}
                      >
                        {header.title}
                      </TableSortLabel>
                    ) : (
                      header.title
                    )}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {stableSort(search(rows, query), getSorting(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map(({ key, row }) => (
                  <TableRow
                    className={classes.tableItem}
                    key={genericKey++}
                    hover
                    onClick={() => onRowClick(key)}
                  >
                    {row.map(cell => (
                      <TableCell key={genericKey++}>{cell}</TableCell>
                    ))}
                  </TableRow>
                ))}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[10, 25, 50, 100, 250]}
                  count={rows.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  SelectProps={{
                    inputProps: { "aria-label": "rows per page" },
                    native: true
                  }}
                  onChangePage={handleChangePage}
                  onChangeRowsPerPage={handleChangeRowsPerPage}
                  ActionsComponent={PaginationActions}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </div>
      </Paper>
    </div>
  );
};

function desc(a, b, orderBy) {
  if (b.row[orderBy] < a.row[orderBy]) {
    return -1;
  }
  if (b.row[orderBy] > a.row[orderBy]) {
    return 1;
  }
  return 0;
}

function search(rows, query) {
  if (query === "") return rows;
  let result = [];
  rows.map(({ key, row, searching }) => {
    if (
      searching
        .toString()
        .toUpperCase()
        .includes(query.toUpperCase())
    )
      result.push({ key, row });
  });
  return result;
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
  return order === "desc"
    ? (a, b) => desc(a, b, orderBy)
    : (a, b) => -desc(a, b, orderBy);
}

export default MainTable;

const useTableStyles = makeStyles(theme => ({
  tableWrapper: {
    margin: theme.spacing(1)
  },
  header: {
    color: theme.palette.primary.main,
    fontWeight: "bold"
  },
  pageTitle: {
    fontWeight: "bold",
    fontSize: "1.6em"
  },
  pageSubTitle: {
    marginTop: theme.spacing(1)
  },
  tableItem: {
    cursor: "pointer"
  },
  searchContainer: {
    display: "flex",
    justifyContent: "flex-end"
  }
}));
